import { makeStyles } from '@mui/styles';
import { MasonTheme } from '@bymason-private/controller-v1-theme-augmentation';
import { Card } from '../../mui/Card';
import { CardActionArea } from '../../mui/CardActionArea';
import { Typography } from '../../mui/Typography';
import clsx from 'clsx';

const useStyles = makeStyles((theme: MasonTheme) => ({
  card: {
    borderRadius: theme.spacing(1),
    color: theme.palette.primary.main,
    width: 'fit-content',
    '&:last-child': {
      marginRight: 0,
    },
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  cardAction: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    alignItems: 'center',
    width: 279,
    height: 226,
  },
  normal: {
    paddingTop: 14,
    width: 192,
  },
  wide: {
    paddingTop: 27,
    width: 279,
  },
  text: {
    fontWeight: 500,
    padding: theme.spacing(1, 0, 2, 0),
    whiteSpace: 'nowrap',
  },
}));

export function LinkCard({
  cardClasses,
  Component,
  message,
  size = 'normal',
  ...cardActionProps
}: CardLinkProps) {
  const classes = useStyles();

  return (
    <Card className={clsx([cardClasses, classes.card])} variant='outlined' color='secondary'>
      <CardActionArea className={clsx(classes.cardAction, classes[size])} {...cardActionProps}>
        <div>{Component}</div>
        <Typography className={classes.text} variant='body2' component='div'>
          {message}
        </Typography>
      </CardActionArea>
    </Card>
  );
}

interface CardLinkProps {
  cardClasses?: string;
  Component: JSX.Element;
  message?: string;
  href?: string;
  target?: string;
  rel?: string;
  size?: 'normal' | 'wide';
  onClick?: () => void;
}
